import { client } from './client'
import type { Prompt, CreatePromptRequest, UpdatePromptRequest, PromptStats } from '@/types'

export const promptsApi = {
  getAll: (projectId: string) =>
    client.get<Prompt[]>(`/projects/${projectId}/prompts`).then(r => r.data),

  getStats: (projectId: string) =>
    client.get<PromptStats>(`/projects/${projectId}/prompts/stats`).then(r => r.data),

  create: (projectId: string, data: CreatePromptRequest) =>
    client.post(`/projects/${projectId}/prompts`, data).then(r => r.data),

  update: (projectId: string, id: string, data: UpdatePromptRequest) =>
    client.put(`/projects/${projectId}/prompts/${id}`, data).then(r => r.data),

  delete: (projectId: string, id: string) =>
    client.delete(`/projects/${projectId}/prompts/${id}`).then(r => r.data),
}
